import type { EventSummary } from '../../events/types';
import { API_BASE } from '../../services/api';

interface EventCardProps {
  event: EventSummary;
  compact?: boolean;
  onJoin?: (eventId: number) => void;
  onOpen?: (eventId: number) => void;
  joining?: boolean;
}

const taskTypeLabel: Record<EventSummary['task_type'], string> = {
  text: 'Текстовое задание',
  file: 'Файловое задание',
  confirmation: 'Подтверждение',
};

const formatDeadline = (value: string) => new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
}).format(new Date(value));

const EventCard = ({ event, compact = false, onJoin, onOpen, joining = false }: EventCardProps) => (
  <article data-testid={`event-card-${event.id}`} className={`shark-card shark-border overflow-hidden rounded-2xl border ${compact ? 'p-3' : 'p-5'}`}>
    <div className={`mb-3 overflow-hidden rounded-xl ${compact ? 'h-24' : 'h-40'}`}>
      {event.cover_url ? (
        <img src={`${API_BASE}${event.cover_url}`} alt={`Обложка события ${event.title}`} className="h-full w-full object-cover" />
      ) : (
        <div aria-label="Обложка отсутствует" className="flex h-full w-full items-center justify-center bg-gradient-to-br from-blue-600/40 via-cyan-500/20 to-emerald-500/30 text-3xl" role="img">🦈</div>
      )}
    </div>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className={`${compact ? 'text-base' : 'text-xl'} truncate font-bold text-white`}>{event.title}</h2>
        <p className="shark-muted mt-1 text-xs">{taskTypeLabel[event.task_type]}</p>
      </div>
      <span className="shark-accent-text shrink-0 text-xs font-bold">{event.can_submit ? 'Можно отправить' : event.can_join ? 'Доступно' : 'Недоступно'}</span>
    </div>
    {!compact && <p className="shark-muted mt-3 text-sm">{event.description}</p>}
    <div className="shark-muted mt-3 flex flex-wrap gap-x-4 gap-y-1 text-xs">
      <span>До: {formatDeadline(event.end_at)}</span>
      <span>Участников: {event.participant_count}</span>
    </div>
    <div className="mt-4 flex flex-wrap gap-2">
      {onOpen && <button type="button" onClick={() => onOpen(event.id)} aria-label={`Подробнее о событии ${event.title}`} className="shark-density-control rounded-xl border border-gray-700 text-sm font-bold text-gray-300 hover:bg-gray-800">Подробнее</button>}
      {event.can_join && onJoin && <button type="button" onClick={() => onJoin(event.id)} disabled={joining} aria-label={`Присоединиться к событию ${event.title}`} className="shark-accent-button shark-density-control rounded-xl text-sm font-bold disabled:cursor-not-allowed disabled:opacity-50">{joining ? 'Присоединяемся...' : 'Присоединиться'}</button>}
    </div>
  </article>
);

export default EventCard;
